<template>
  <div class="is-clearfix">
    <!--<a class="is-pulled-left">忘记密码</a>-->
    <a class="is-pulled-right has-text-centered lxm-login-attached-button__right" @click="rightClicked">{{ rightText }}</a>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  .lxm-login-attached-button__right
    color: white
    font-size: siz(12)
    border-bottom: 0.07rem solid login-primary
    margin-top: spacing-small
    padding: 0 siz(7) siz(4)
</style>

<script>
  import * as mTypes from '../../../store/mutation-types'
  export default {
    props: {
      rightTo: [Object, String],
      rightText: String
    },
    methods: {
      rightClicked () {
        this.$emit('right-click')
        this.$store.commit(mTypes.TRANSITION_SET_BACK)
        this.$router.push(this.rightTo)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AttachedButton.vue?c2f5b450